/**
 * 유입경로 추적 유틸리티
 * 사용자가 처음 방문할 때 유입경로 정보를 수집하고 localStorage에 저장
 */

const REFERRAL_KEY = 'ttaechang_referral_data'

/**
 * 도메인에서 유입 소스 분류
 */
const classifyReferralSource = (referrerUrl) => {
  if (!referrerUrl) return 'direct'

  try {
    const url = new URL(referrerUrl)
    const hostname = url.hostname.toLowerCase()

    // 검색엔진
    if (hostname.includes('google')) return 'google'
    if (hostname.includes('naver')) return 'naver'
    if (hostname.includes('daum')) return 'daum'
    if (hostname.includes('bing')) return 'bing'
    if (hostname.includes('yahoo')) return 'yahoo'

    // SNS
    if (hostname.includes('instagram')) return 'instagram'
    if (hostname.includes('facebook') || hostname.includes('fb.com')) return 'facebook'
    if (hostname.includes('twitter') || hostname.includes('x.com')) return 'twitter'
    if (hostname.includes('tiktok')) return 'tiktok'
    if (hostname.includes('youtube')) return 'youtube'

    // 메신저
    if (hostname.includes('kakao')) return 'kakao'
    if (hostname.includes('line')) return 'line'

    // 커뮤니티
    if (hostname.includes('reddit')) return 'reddit'
    if (hostname.includes('dcinside')) return 'dcinside'
    if (hostname.includes('fmkorea')) return 'fmkorea'
    if (hostname.includes('theqoo')) return 'theqoo'
    if (hostname.includes('instiz')) return 'instiz'

    return 'other'
  } catch {
    return 'other'
  }
}

/**
 * URL에서 UTM 파라미터 추출
 */
const extractUtmParams = (urlString) => {
  try {
    const url = new URL(urlString)
    return {
      utmSource: url.searchParams.get('utm_source') || null,
      utmMedium: url.searchParams.get('utm_medium') || null,
      utmCampaign: url.searchParams.get('utm_campaign') || null
    }
  } catch {
    return {
      utmSource: null,
      utmMedium: null,
      utmCampaign: null
    }
  }
}

/**
 * 첫 방문 시 유입경로 정보 수집 및 저장
 * App.vue의 onMounted에서 호출
 */
export const captureReferralData = () => {
  // 이미 저장된 데이터가 있으면 덮어쓰지 않음 (첫 방문 기록 유지)
  const existingData = localStorage.getItem(REFERRAL_KEY)
  if (existingData) {
    console.log('[ReferralTracker] 기존 유입경로 데이터 존재:', JSON.parse(existingData))
    return
  }

  const referrerUrl = document.referrer || ''
  const currentUrl = window.location.href
  const landingPage = window.location.pathname

  // UTM 파라미터 추출
  const utmParams = extractUtmParams(currentUrl)

  // 유입 소스 분류 (UTM source가 있으면 우선 사용)
  let referralSource = utmParams.utmSource || classifyReferralSource(referrerUrl)

  const referralData = {
    referralSource,
    referralUrl: referrerUrl || null,
    utmSource: utmParams.utmSource,
    utmMedium: utmParams.utmMedium,
    utmCampaign: utmParams.utmCampaign,
    landingPage,
    capturedAt: new Date().toISOString()
  }

  localStorage.setItem(REFERRAL_KEY, JSON.stringify(referralData))
  console.log('[ReferralTracker] 유입경로 데이터 저장됨:', referralData)
}

/**
 * 저장된 유입경로 데이터 조회
 */
export const getReferralData = () => {
  const data = localStorage.getItem(REFERRAL_KEY)
  if (!data) return null

  try {
    return JSON.parse(data)
  } catch {
    return null
  }
}

/**
 * 유입경로 데이터 삭제 (회원가입 완료 후 호출)
 */
export const clearReferralData = () => {
  localStorage.removeItem(REFERRAL_KEY)
  console.log('[ReferralTracker] 유입경로 데이터 삭제됨')
}

export default {
  captureReferralData,
  getReferralData,
  clearReferralData
}
